import React, { useEffect, useState } from "react";
import { Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  /**if  chart is progress card only can use this parameter*/
  inComplete: number;
  complete: number;
  upComing: number;
  total?: number;
  theme: "light" | "dark";
  /**The circular progress bar can be categorized into two types based on the number of layers it has. These types indicate whether the circular progress bar consists of two layers or three layers*/
  isThreeLayer?: boolean;
  /**If and only if a circular progress bar has three layers, it can be determined that it represents an AI circular progress bar or other type*/
  isAi?: boolean;
  /**If the circular progress bar represents AI, it should display a percentage indicating the progress or completion*/
  aiPercentage?: number;
  // Show blank inner circle When no result
  isAiNoResult?: boolean;
}

export const CircularProgressBar = ({
  inComplete,
  complete,
  upComing,
  theme,
  isThreeLayer,
  isAi,
  aiPercentage,
  isAiNoResult,
  total,
}: IProps) => {
  const [first, setFirst] = useState("");
  const [aifirst, setAiFirst] = useState("");
  const [second, setSecond] = useState("");
  const [upComingStockColor, setUpComingStockColor] = useState(
    theme === "light" ? "#eeeeee" : "#3d444d"
  );

  useEffect(() => {
    let firstEndDegree = 0;
    let secondEndDegree = 0;

    if (complete !== 0 && inComplete !== 0 && upComing !== 0) {
      firstEndDegree = Math.round(
        (inComplete * 360) / (inComplete + complete + upComing)
      );
      secondEndDegree = Math.round(
        (upComing * 360) / (inComplete + complete + upComing)
      );
    } else if (complete !== 0 && inComplete !== 0 && upComing === 0) {
      firstEndDegree = Math.round(
        (inComplete * 360) / (inComplete + complete + upComing)
      );
      secondEndDegree = 0;
    } else if (complete === 0 && inComplete !== 0 && upComing !== 0) {
      firstEndDegree = Math.round(
        (inComplete * 360) / (inComplete + complete + upComing)
      );
      secondEndDegree = Math.round(
        (upComing * 360) / (inComplete + complete + upComing)
      );
    } else if (complete === 0 && inComplete !== 0 && upComing === 0) {
      firstEndDegree = Math.round(
        (inComplete * 360) / (inComplete + complete + upComing)
      );
      secondEndDegree = 0;
    } else if (complete !== 0 && inComplete === 0 && upComing !== 0) {
      firstEndDegree = 0;
      secondEndDegree = Math.round(
        (upComing * 360) / (inComplete + complete + upComing)
      );
    } else if (complete !== 0 && inComplete === 0 && upComing === 0) {
      firstEndDegree = 0;
      secondEndDegree = 0;
    } else if (complete === 0 && inComplete === 0 && upComing !== 0) {
      firstEndDegree = 0;
      secondEndDegree = Math.round(
        (upComing * 360) / (inComplete + complete + upComing)
      );
    } else {
      firstEndDegree = 0;
      secondEndDegree = 360;
    }

    setFirst(`${firstEndDegree}deg`);
    setSecond(`${firstEndDegree + secondEndDegree}deg`);

    if (theme === "dark") {
      setUpComingStockColor("#3d444d");
    }

    if (theme === "light") {
      setUpComingStockColor("#eeeeee");
    }
  }, [inComplete, complete, upComing, theme]);

  useEffect(() => {
    let aiFirstEndDegree = 0;

    if (aiPercentage !== 0 && aiPercentage) {
      aiFirstEndDegree = Math.round((aiPercentage * 360) / 100);
    }

    setAiFirst(`${aiFirstEndDegree}deg`);
  }, [aiPercentage]);

  return !isThreeLayer ? (
    <div
      className="pie-chart"
      style={{
        background: `conic-gradient(
      #fc706f 0% ${first},
      ${upComingStockColor} ${first} ${second},
      #71bf8f ${second} 360deg
    )`,
      }}
    >
      <div
        className="inner-circle"
        style={{ backgroundColor: theme === "light" ? "#fff" : "#1C1F23" }}
      >
        <div className="text-section">
          <div className="both-text-wrapper">
            <div className="first">
              <Typography
                label={`${complete}`}
                variant="h4Med"
                styles="complete-number-text"
              />
              <Typography
                variant="h9Medium"
                label={`/${total ? total : inComplete + complete + upComing}`}
                styles="chart-second-text-style"
              />
            </div>
            <div className="second">
              <Typography
                label="Complete"
                variant="h9Medium"
                styles="chart-second-text-style"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : isAi ? (
    <div
      className="pie-chart-three-layer"
      style={{
        background: isAiNoResult
          ? theme === "light"
            ? "#EEEEEE"
            : "#3D444D"
          : theme === "light" ? `conic-gradient(
                  #0470A9 0% ${aifirst},
          #EAF3F9 ${aifirst} 360deg
        )` : `conic-gradient(
                  #3272BE 0% ${aifirst},
          #3D444D ${aifirst} 360deg
        )`,
      }}
    >
      <div
        className="inner-circle"
        style={{ background: theme === "light" ? "#FFFFFF" : "#262C33" }}
      >
        <div
          className="inner-inner-circle"
          style={{
            background: isAiNoResult
              ? theme === "light"
                ? "#EEEEEE"
                : "#3D444D"
              : theme === "light"
                ? "#D7E7F9"
                : "#233851",
          }}
        >
          <div className="text-section">
            <div className="first-ai">
              {isAiNoResult ? null : (
                <Typography
                  label={`${aiPercentage}%`}
                  variant="h4Med"
                  styles="complete-number-text-ai"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      className="pie-chart-three-layer"
      style={{
        background: `conic-gradient(
        #fc706f 0% ${first},
        ${upComingStockColor} ${first} ${second},
        #71bf8f ${second} 360deg
      )`,
      }}
    >
      <div
        className="inner-circle"
        style={{ background: theme === "light" ? "#fff" : "#1C1F23" }}
      >
        <div
          className="inner-inner-circle"
          style={{ background: theme === "light" ? "#EEEEEE" : "#3D444D" }}
        >
          <div className="text-section">
            <div className="both-text-wrapper">
              <div className="first">
                <Typography
                  label={`${complete}`}
                  variant="h4Med"
                  styles="complete-number-text"
                />
                <Typography
                  variant="h9Medium"
                  label={`/${total ? total : inComplete + complete + upComing}`}
                  styles="chart-second-text-style"
                />
              </div>
              <div className="second">
                <Typography
                  label="completed"
                  variant="h9Medium"
                  styles="chart-second-text-style"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
